module.exports = __webpack_public_path__ + "img/gold2.0a15955e.png";